// extracted by mini-css-extract-plugin
export default {"fixedPrice":"styles_fixedPrice__zU3OL"};